import { createFeatureSelector, createSelector } from '@ngrx/store';
import { itemCodeStringValuesFeatureKey } from './item-code-strings.reducer';
import { CodeStringGroup, CodeStringGroupValue, CodeStringSegment, CodeStringSegmentValue, CodeStringValues } from 'src/app/models/pricing-view-models';

export const selectItemCodeStringValuesState = createFeatureSelector<CodeStringValues>(itemCodeStringValuesFeatureKey);

export const selectItemCodeStringValues = createSelector(
  selectItemCodeStringValuesState,
  (state: CodeStringValues) => {
    let groups  = state.CodeStringGroupValues;
    
    let rtn: CodeStringGroupValue[] = [];

    //let groups = { ...state, CodeStringGroupValues: groups } as CodeStringValues;
    groups.forEach((group: CodeStringGroupValue) => {
      let gv = { ...group, DisplayName: group.CodeStringGroup.DisplayName, DisplayValue: getCodeStringGroupDisplayValue(group) } as CodeStringGroupValue;
      //group.DisplayName = group.CodeStringGroup.DisplayName;
      //group.DisplayValue = getCodeStringGroupDisplayValue(group);
      rtn.push(gv);
    });

    return rtn;
  }
);

function getCodeStringGroupDisplayValue(gv: CodeStringGroupValue): string {
  let rtn = '';

  let segments: CodeStringSegmentValue[] = [...gv.CodeStringSegmentValues];
  segments = segments.sort((a, b) => a.CodeStringSegment.StartPosition - b.CodeStringSegment.StartPosition);

  segments.forEach((segment: CodeStringSegmentValue) => {
    try {
      let len = segment.CodeStringSegment.Length;
      let val = '';
      if (segment.CodeStringValue === undefined || segment.CodeStringValue === null) {
        rtn += '_'.repeat(len);
      } else {
        val = segment.CodeStringValue;
        val += '?'.repeat(len - val.length);
        rtn += val;
      }
    } catch(e) {
      console.log('get code string error', gv, e);
    }
  });

  return rtn;
}

// export const selectProductCodeStringSegmentsState =
//   createFeatureSelector<ProductCodeStringSegmentsState>(productCodeStringSegmentsFeatureKey);

// export const selectAllProductCodeStringSegments = createSelector(
//   selectProductCodeStringSegmentsState,
//   (state: ProductCodeStringSegmentsState) => state.codeStringSegments
// );

// export const selectCurrentCommonCodeString = createSelector(
//   selectProductCodeStringSegmentsState,
//   (state: ProductCodeStringSegmentsState) => state.currentCommonString
// );

// export const selectCurrentValveCodeString = createSelector(
//   selectProductCodeStringSegmentsState,
//   (state: ProductCodeStringSegmentsState) => state.currentValveString
// );

// export const selectCurrentCeilingPanelCodeString = createSelector(
//   selectProductCodeStringSegmentsState,
//   (state: ProductCodeStringSegmentsState) => state.currentCeilingPanelString
// );


// //get code strings that have been saved and calculated via the reduce
// export const selectCodeStringsState = createFeatureSelector<ItemAllCodeStringsState[]>("codeStrings");

// export const itemAllCodeStrings = createSelector(
//   selectCodeStringsState,
//   (state: ItemAllCodeStringsState[]) => state
// );
